<div *ngIf="isCompanyView" class="create-button-container" fxLayout fxLayoutAlign="flex-end center">
  <button
    mat-button
    class="header-button"
    fxLayout
    fxLayoutAlign="center center"
    [disabled]="isCreating"
    (click)="toggleCreationMode()"
  >
    {{'CREATE_NEW_ROLE' | translate}}
  </button>
</div>

<ng-container *ngIf="isCreating || roles.length">
  <div class="content">
    <div class="panels-header">
      <div *ngIf="isOrderView"></div>
      <span fxFlex="35">{{'EMPLOYEE_ROLE' | translate}}</span>
      <span fxFlex="20">{{'DATE_CREATED' | translate}}</span>
      <span fxFlex="45">{{'ACTIONS' | translate}}</span>
    </div>
    <div *ngIf="isCreating" class="creation-field" fxLayout fxLayoutAlign="space-between center">
      <mat-form-field appearance="legacy">
        <mat-label>{{'SPECIFY_ROLE_NAME' | translate}}</mat-label>
        <input id="create" type="text" matInput [autofocus]="true" [formControl]="creationFormControl">
      </mat-form-field>
      <div class="creation-actions" fxLayout fxLayoutAlign="flex-end center" fxLayoutGap="16px">
        <button mat-icon-button [disabled]="!creationFormControl.value" (click)="saveNewRequirementGroup()">
          <mat-icon>check</mat-icon>
        </button>
        <button mat-icon-button (click)="cancelCreationMode()"><mat-icon>close</mat-icon></button>
      </div>
    </div>
    <mat-accordion>
      <mat-expansion-panel
        *ngFor="let panel of roles; let i = index"
        [class.bg-yellow]="panel.chosen"
        [disabled]="panel.isEditing"
        (opened)="onPanelOpen(panel, i)"
        (closed)="onPanelClosed(panel)"
      >
        <mat-expansion-panel-header>
          <div class="panel-description" fxLayout fxLayoutAlign="flex-start center" fxLayoutGap="3px">
            <mat-radio-button
              *ngIf="isOrderView"
              [checked]="panel.chosen"
              (change)="onChoose(i, $event)"
              (click)="$event.stopPropagation()"
            >
            </mat-radio-button>
            <div *ngIf="panel?.isEditing" class="creation-field edit" fxLayout fxLayoutAlign="space-between center">
              <mat-form-field appearance="legacy">
                <input id="rename" type="text" matInput autofocus [formControl]="editingFormControl" (click)="$event.stopPropagation();">
              </mat-form-field>
              <div class="creation-actions" fxLayout fxLayoutAlign="flex-end center" fxLayoutGap="16px">
                <button mat-icon-button [disabled]="!editingFormControl.value" (click)="editRequirementForm(i); $event.stopPropagation();">
                  <mat-icon>check</mat-icon>
                </button>
                <button mat-icon-button (click)="cancelEdit(i); $event.stopPropagation();"><mat-icon>close</mat-icon></button>
              </div>
            </div>
            <ng-container *ngIf="!panel?.isEditing">
              <span fxFlex="35" class="role">{{panel.name}}</span>
              <span fxFlex="20" class="date">{{moment(panel.createdAt).locale(momentLang).format('MMMM DD, YYYY')}}</span>
              <div fxFlex="45" class="panel-actions" fxLayout fxLayoutAlign="flex-start center" fxLayoutGap="16px">
              <span class="action" (click)="toggleEditingMode(i); $event.stopPropagation();">
                <mat-icon>edit</mat-icon>{{'RENAME' | translate}}
              </span>
                <span class="action" (click)="duplicateRole(i); $event.stopPropagation();">
                <mat-icon>content_copy</mat-icon>{{'DUPLICATE' | translate}}
              </span>
                <span class="action" (click)="deleteRole(i); $event.stopPropagation();">
                <mat-icon>delete_forever</mat-icon>{{'DELETE' | translate}}
              </span>
              </div>
            </ng-container>
          </div>
        </mat-expansion-panel-header>
        <div style="width: 100%" cdkDropList (cdkDropListDropped)="onDrop($event, panel.actions, i)">
          <div
            *ngFor="let requirement of panel.actions"
            class="requirement"
            fxLayout
            fxLayoutAlign="flex-start center"
            fxLayoutGap="8px"
            cdkDrag
          >
            <mat-icon>drag_indicator</mat-icon>
            <mat-form-field>
              <input type="text" matInput [formControl]="requirement">
            </mat-form-field>
          </div>
        </div>
        <span class="add-requirement" (click)="addRequirement(panel, i)">
        <mat-icon>add</mat-icon>
          {{'ADD_REQUIREMENT' | translate}}
      </span>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</ng-container>

<div *ngIf="!isCompanyView" class="footer" [class.add-padding-top]="!isCreating && !roles.length" fxLayout fxLayoutAlign="flex-end center" fxLayoutGap="8px">
  <button mat-button class="cancel" (click)="dialogCloseChange.emit(false)">{{'CANCEL' | translate}}</button>
  <button
    mat-button
    class="create"
    (click)="isOrderView ? mergedOrderViewChange() : onCreate()"
  >{{(!!roles.length ? 'SAVE' : 'COMMON.CREATE') | translate}}</button>
</div>
